import { getFormattedMonth } from '../../../utils/date';

import { MILLION } from './constants';

const formatFundingDate = fundingDate => {
  if (!fundingDate) {
    return '';
  }

  const dateValues = fundingDate.split('-');
  const fundingYear = dateValues[0];
  const fundingMonth = getFormattedMonth(fundingDate);
  const fundingDay = dateValues[2];

  return `${fundingMonth} ${fundingDay}, ${fundingYear}`;
};

const formatFundingSummary = fundingSummary => {
  if (!fundingSummary || !fundingSummary?.value) {
    return null;
  }
  const {
    total_fund_events: numberOfFundingRounds,
    value: totalFunding,
    last_funding_round_usd: lastFundingAmount,
    value_usd: totalFundingInUsd,
    last_funding_round_name: lastFundingName,
    ipo_date: fundingDate,
  } = fundingSummary;

  const formattedTotalFunding = Math.floor((totalFundingInUsd || totalFunding) / MILLION);

  return {
    fundingDate: formatFundingDate(fundingDate),
    numberOfFundingRounds,
    lastFundingAmount: Math.floor(lastFundingAmount / MILLION),
    totalFunding: formattedTotalFunding,
    lastFundingName,
  };
};

export {
  formatFundingDate,
  formatFundingSummary,
};
